import './style';

import Body from './components/Body';

export default function App() {
  return <Body />;
}
